module.exports = __webpack_public_path__ + "img/profile-bg1.1e15e2a1.jpg";